import { useEffect } from 'preact/hooks';
import { useVPAIDVolume } from './useVPAIDVolume';

export function useSetVideoSlotVolume(videoSlot: HTMLVideoElement) {
  const volume = useVPAIDVolume();
  useEffect(() => {
    const muted = volume <= 0.001;
    videoSlot.muted = muted;
    videoSlot.volume = muted ? 0 : volume;
  }, [volume]);
}
